/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
//utils
import { isAddOnValid } from 'utils/embedcontentvalidation';
// material
import { Page, Content, Copy, BodyCopy } from '@insticator/insticator-ui'; // iui-material
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
import EmailCollection from 'pages/dashboard/embeds/management/addons/addontypes/emailcollection/emailcollection_container';
import AddOnCard from 'pages/dashboard/embeds/management/addons/addoncard/addoncard';
import PreviewPage from 'pages/dashboard/embeds/management/preview/preview_container';

// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/addons/addons_styles';



/* ========== ~~~~~~~~~~ EMBED REVENUE ~~~~~~~~~~ ========== */
class AddOnsPage extends Component {
    constructor(props){
        super(props);

    }
    componentWillUnmount() {
        this.props.setEditingAddOn(null);
    }

    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    handleAddOnSave = () => {
        if(!!this.props.editingAddOn){
            if(isAddOnValid(this.props.editingAddOn, this.handleCurrentAddOnData(this.props.editingAddOn))){
                this.props.invalidateActiveAddOn(this.props.editingAddOn);
                return this.props.handleSaveEmbed()
            }
            this.props.sendErrorMessage('There are required fields you must fill out before continuing. Please check if all the options are unique.');
            return this.props.invalidateActiveAddOn(this.props.editingAddOn);
        }
        return this.props.handleSaveEmbed()
    };

    handleCurrentAddOnData = type => {
        switch (type) {
            case 'EMAIL_COLLECTION':
            default:
                return this.props.userDataCollection;
        }
    };

    handleToggle =(itemToToggle) => {
        this.props.toggleAddOnItem(itemToToggle);
    };

    emailCollectionDescription = () => 'Enabling Collect User Emails allows users interacting with your Insticator content embed to provide their email address for marketing or subscription purposes.';

    handleCreationCTA = type => {
      switch (type) {
          case 'EMAIL_COLLECTION':
          default:
              return ({
                  action: ()=> this.props.setEditingAddOn('EMAIL_COLLECTION'),
                  ctaText: !!this.props.emailCollectionDataPresent ? 'Edit' : 'Create User Email Page',
                  icon: !!this.props.emailCollectionDataPresent ? 'edit' : 'plus'
              })
      }
    };

    handleCardClose = () => {
        this.props.discardChanges();
        this.props.setEditingAddOn(null);
    };

    handleEmailCollectionToggle = () => {
        if(!this.props.emailCollectionDataPresent){
            this.props.setEditingAddOn('EMAIL_COLLECTION');
        }
        this.handleToggle('showUserDataCollection');
    };

    handlePreview = (addOn) => {
        if(isAddOnValid(addOn, this.handleCurrentAddOnData(addOn))) {
            this.props.displayModal(true, <PreviewPage addOn={addOn} />);
            if(addOn) this.props.invalidateActiveAddOn(addOn);
        } else {
            this.props.invalidateActiveAddOn(addOn);
            this.props.sendErrorMessage('There are required fields you must fill out before continuing.');
        }
    };
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        const location = this.props.location === 'in-content' ? 'incontent' : 'rail';
        return(
            <Page name={`addons`} klass={`${this.props.classes.addons} saving-${this.props.isSavingData} ${this.isStep()}`}>
                <Content>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <Copy>
                        <BodyCopy>
                            <p>In addition to Ads, you can enable <strong>Collect User Emails</strong> </p>
                        </BodyCopy>
                    </Copy>
                    <div className={'list'}>
                        <AddOnCard
                            image={'illustration-addon-email.svg'}
                            title={'Collect User Emails'}
                            toggle={!!this.props.selectedEmbedData.showUserDataCollection}
                            toggleClick={this.handleEmailCollectionToggle}
                            description={this.emailCollectionDescription()}
                            createCTA={this.handleCreationCTA('EMAIL_COLLECTION')}
                            createMode={this.props.editingAddOn === 'EMAIL_COLLECTION'}
                            creationElement={<EmailCollection close={this.handleCardClose} handlePreview={this.handlePreview}/>}
                            footerNote={!this.props.emailCollectionDataPresent ? 'To use this add-on, please create its page' : null}
                            addOnSaved={!!this.props.emailCollectionDataPresent}
                            previewAction={()=>this.handlePreview('EMAIL_COLLECTION')}
                        />
                    </div>
                    <FlowControls handleSaveEmbed={this.handleAddOnSave} />
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddOnsPage);
